// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"24":"eb322e40","88":"72985bf9","265":"192b8d55","310":"522d865d","420":"55076cb2","607":"ac08f683","807":"07edcde3","826":"c1677e41"}[chunkId] + ".js";
};